var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":"","color":_vm.config.color,"text-color":_vm.config.textColor,"label":""}},[_c('v-icon',{attrs:{"left":"","x-small":""}},[_vm._v(_vm._s(_vm.config.icon))]),_vm._v(" "+_vm._s(_vm.label || _vm.config.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }